import { render, staticRenderFns } from "./DropdownMenuTest.vue?vue&type=template&id=dec811fe&"
import script from "./DropdownMenuTest.vue?vue&type=script&lang=js&"
export * from "./DropdownMenuTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports